export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11400.4215c122.jpg";